<template>
    <div class="price-range">
        <div class="row">
            <div class="col-6">
                <div class="mb-3">
                    <input type="tel" class="form-control" :name="price_from" v-model="price[0]">
                </div>
            </div>
            <div class="col-6">
                <div class="mb-3">
                    <input type="tel" class="form-control" :name="price_to" v-model="price[1]">
                </div>
            </div>
        </div>
        <Slider
            v-model="price"
            class="d-none d-md-block"
            :format="format"
            :min="min"
            :max="max"
            :step="step"
            :tooltips="false" />
        <div class="d-none d-md-flex justify-content-between">
            <em>{{min}}&euro;</em>
            <em>{{max}}&euro;</em>
        </div>
    </div>
</template>

<script>
    import Slider from '@vueform/slider';

    export default {
        name: 'PriceRange',
        components: {
            Slider,
        },
        data() {
            return {
                format: {
                    suffix: ' &euro;',
                    decimals: 0,
                    thousand: ' ',
                },
                price: this.value.length ? this.value : [
                    this.min,
                    this.max / 2,
                ],
            };
        },
        computed: {
            price_from() {
                if (/\./.test(this.name)) {
                    return `${this.name.replace('.', '[')}_from]`;
                }

                return `${this.name}[from]`;
            },
            price_to() {
                if (/\./.test(this.name)) {
                    return `${this.name.replace('.', '[')}_to]`;
                }

                return `${this.name}[to]`;
            },
        },
        props: {
            name: {
                type: String,
                default: 'price',
            },
            min: {
                type: Number,
                default: 0,
            },
            max: {
                type: Number,
                default: 100,
            },
            step: {
                type: Number,
                default: 10,
            },
            value: {
                type: Array,
                default() {
                    return [];
                },
            },
        },
    }
</script>

<style lang="scss">
    :root {
        --slider-bg: #74a6ba;
        --slider-connect-bg: #101010;
        --slider-connect-bg-disabled: #9CA3AF;
        --slider-height: 2px;
        --slider-radius: 0;

        --slider-handle-bg: #101010;
        --slider-handle-border: 0;
        --slider-handle-width: 7px;
        --slider-handle-height: 7px;
        --slider-handle-radius: 50%;
        --slider-handle-shadow: none;
        --slider-handle-shadow-active: none;
        --slider-handle-ring-width: 0;
        --slider-handle-ring-color: transparent;
    }
</style>
